var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 20.6667V16H20.6667L20.6678 20.6667H16ZM20.6667 13.6667H16C14.7132 13.6667 13.6667 14.7132 13.6667 16V20.6667C13.6667 21.9535 14.7132 23 16 23H20.6667C21.9535 23 23 21.9535 23 20.6667V16C23 14.7132 21.9535 13.6667 20.6667 13.6667V13.6667ZM4.33333 20.6667V16H9L9.00117 20.6667H4.33333ZM9 13.6667H4.33333C3.0465 13.6667 2 14.7132 2 16V20.6667C2 21.9535 3.0465 23 4.33333 23H9C10.2868 23 11.3333 21.9535 11.3333 20.6667V16C11.3333 14.7132 10.2868 13.6667 9 13.6667V13.6667ZM16 9V4.33333H20.6667L20.6678 9H16ZM20.6667 2H16C14.7132 2 13.6667 3.0465 13.6667 4.33333V9C13.6667 10.2868 14.7132 11.3333 16 11.3333H20.6667C21.9535 11.3333 23 10.2868 23 9V4.33333C23 3.0465 21.9535 2 20.6667 2V2ZM4.33333 9V4.33333H9L9.00117 9H4.33333ZM9 2H4.33333C3.0465 2 2 3.0465 2 4.33333V9C2 10.2868 3.0465 11.3333 4.33333 11.3333H9C10.2868 11.3333 11.3333 10.2868 11.3333 9V4.33333C11.3333 3.0465 10.2868 2 9 2V2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f541f2403cafb1c91722b57dd6005c78.svg";
export { ForwardRef as ReactComponent };